module.exports = __webpack_public_path__ + "static/media/_MIC2312.image.ca050c18.png";